/**
 * Matematica DETERMINISTICA per la simulazione.
 *
 * ⚠️ RISCHIO TECNICO #1 del progetto (vedi docs/contesto-sviluppo.md §4.1):
 * Math.sin/cos/tan/pow/exp possono restituire ULP diversi tra i motori JS
 * (V8 / JavaScriptCore / SpiderMonkey). Una sim che li usa produce ghost che
 * driftano e verify-replay lato server che boccia run oneste.
 *
 * REGOLA FERREA per tutto ciò che sta in src/game/ e influenza lo stato:
 *   - Consentiti SOLO: + − × ÷, confronti, Math.floor/abs, Math.sqrt.
 *     (Math.sqrt è correttamente arrotondato da IEEE-754 → identico ovunque.)
 *   - VIETATI in sim: sin/cos/tan/pow/exp/hypot/atan e Date.now/Math.random.
 *   - Le pendenze si ricavano per differenze finite + normalizzazione con sqrt,
 *     mai con trigonometria.
 *   - Il rumore del terreno usa interpolazione polinomiale (smootherstep),
 *     mai somme di seni.
 */

export function clamp(v: number, lo: number, hi: number): number {
  return v < lo ? lo : v > hi ? hi : v;
}

export function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * t;
}

/** Ken Perlin smootherstep: 6t^5 − 15t^4 + 10t^3. Solo moltiplicazioni → deterministica. */
export function smootherstep(t: number): number {
  return t * t * t * (t * (t * 6 - 15) + 10);
}

/** Lunghezza di un vettore 2D via sqrt (deterministica), MAI Math.hypot. */
export function len2(x: number, y: number): number {
  return Math.sqrt(x * x + y * y);
}

/**
 * Quantizza un float a `decimals` cifre e lo restituisce come stringa stabile.
 * Usato per l'hash di stato dei golden-run: confronta stati "al millimetro"
 * senza inciampare nel rumore dell'ultimo bit.
 */
export function q(v: number, decimals = 3): string {
  const p = Math.pow(10, decimals); // pow qui è FUORI dalla sim (solo per hashing/test) → ok
  return String(Math.round(v * p) / p);
}
